import { render, staticRenderFns } from "./FormFaculteedit.vue?vue&type=template&id=5a026e60&"
import script from "./FormFaculteedit.vue?vue&type=script&lang=js&"
export * from "./FormFaculteedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports